import { auditReports } from '@mi-front/api-clients';
import MemoryIcon from '@mui/icons-material/Memory';
import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { ReprocessErrorInfo } from './ReprocessErrorInfo';

interface Props {
  run: auditReports.AodRun;
  isDisabled: boolean;
  isLoading: boolean;
  onReprocess: () => void;
}

export function ReprocessAction({ run, isDisabled, isLoading, onReprocess }: Props) {
  const { $t } = useIntl();

  if (!run.canReprocess) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <ReprocessErrorInfo run={run} />
      <Box>
        {$t({
          id: 'audit.aod.actions.triggerReprocess.description',
          defaultMessage:
            'Iniciar el reprocesamiento de la orden para luego volver a realizar la ejecución',
        })}
      </Box>
      <Box>
        <Button
          variant="outlined"
          color="warning"
          size="small"
          startIcon={<MemoryIcon />}
          disabled={isDisabled || !run.id}
          loading={isLoading}
          loadingPosition="start"
          onClick={onReprocess}
        >
          {$t({
            id: 'audit.aod.actions.triggerReprocess',
            defaultMessage: 'Reprocesar',
          })}
        </Button>
      </Box>
    </Box>
  );
}
